import { createSlice } from '@reduxjs/toolkit';
import { findAffiliatesAPI } from '../../../service/shop/gplx.affiliate.service';
// utils

const initialState = {
  isLoading: false,
  error: null,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  affiliates: [],
  affiliate: null,
  search: {
    page: 0,
    size: 10,
    value: '',
    orders: [
      {
        order: "desc",
        property: 'createdAt'
      }
    ],
  }
};

const slice = createSlice({
  name: 'shopAffiliate',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
      state.error = null;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setAffiliates(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.affiliates = response.data;
      state.totalElements = response.totalElements;
      state.totalPages = response.totalPages;
      state.numberOfElements = response.numberOfElements;
    },
    setAffiliate(state, action) {
      state.isLoading = false;
      const response = action.payload;
      state.affiliate = response.data;
    },
    setAffiliateSearch(state, action) {
      state.isLoading = false;
      state.search = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;
// Actions
export const { setAffiliateSearch } = slice.actions;
// ----------------------------------------------------------------------

export function getAffiliates() {
  return async (dispatch, getState) => {
    dispatch(slice.actions.startLoading());
    // read state from rootReducer
    const { affiliate: { search } } = getState();
    const resp = await findAffiliatesAPI({ ...search, value: `%${search.value}%` });

    if (resp.code === '200')
      dispatch(slice.actions.setAffiliates(resp));
    else
      dispatch(slice.actions.hasError(resp));
  };
}